import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { GetAlertsParams, Alert } from '../types';
import { AlertsList, AlertsLoading, AlertsState } from './types';

const initialState: AlertsState = {
  loading: {
    getList: false,
    search: false,
    create: false,
    update: false,
    delete: false,
  },
  filter: {    
    limit: 30,
    offset: 0,
    sort: 'date_created_desc',
  },
  list: null,
};

const alertsSlice = createSlice({
  name: 'alerts',
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<Partial<AlertsLoading>>) => {
      state.loading = { ...state.loading, ...action.payload };
    },
    setFilter: (state, action: PayloadAction<Partial<GetAlertsParams>>) => {
      state.filter = { ...state.filter, ...action.payload };
    },
    setList: (state, action: PayloadAction<AlertsList>) => {
      state.list = action.payload;
    },
    resetAlerts: () => {
      return initialState;
    },
    
    addAlertOptimistic: (state, action: PayloadAction<Alert>) => {
      if (state.list) {
        state.list.items.unshift(action.payload);
        state.list.count += 1;
      }
    },
    updateAlertOptimistic: (state, action: PayloadAction<Alert>) => {
      if (state.list) {
        const index = state.list.items.findIndex(alert => alert.id === action.payload.id);
        if (index !== -1) {
          state.list.items[index] = action.payload;
        }
      }
    },
    removeAlertOptimistic: (state, action: PayloadAction<string>) => {
      if (state.list) {
        state.list.items = state.list.items.filter(alert => alert.id !== action.payload);
        state.list.count -= 1;
      }
    },
    
    revertOptimisticUpdate: (state, action: PayloadAction<AlertsList>) => {
      state.list = action.payload;
    },
  },
});

export const { 
  setLoading, 
  setFilter, 
  setList, 
  resetAlerts,
  addAlertOptimistic,
  updateAlertOptimistic,
  removeAlertOptimistic,
  revertOptimisticUpdate
} = alertsSlice.actions;

// Selectors
export const getAlertsLoading = (state: { alerts?: AlertsState }) => state.alerts?.loading || initialState.loading;
export const getAlertsFilter = (state: { alerts?: AlertsState }) => state.alerts?.filter || initialState.filter;
export const getAlertsList = (state: { alerts?: AlertsState }) => state.alerts?.list || initialState.list;

export default alertsSlice.reducer; 